import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description File icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { File } from '@sravni/design-system-icons'
 *
 * <File />
 * ```
 */
var File = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "File", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.345 5.345-2.357-2.357A1.667 1.667 0 0 0 11.81 2.5H5.833c-.92 0-1.666.746-1.666 1.667v11.666c0 .921.746 1.667 1.666 1.667h8.334c.92 0 1.666-.746 1.666-1.667v-9.31c0-.441-.175-.865-.488-1.178Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.833 6.667H12.5a.834.834 0 0 1-.833-.834V2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { File };
//# sourceMappingURL=File.js.map
